<ng-container *ngIf="groupname!='' && groupname!=undefined">
    <mat-card class="chatHeader">
        <div class="userPic" *ngIf="imageUrl">
            <img [src]="imageUrl" alt="" />
        </div>
        <div class="userPic" *ngIf="!imageUrl">
            <span>{{getShortName(groupname)}}</span>
        </div>
        <div class="info">
            <!-- <h3>Matt McAlpin</h3> -->
            <h3>{{groupname}}</h3>
        </div>     
        <!-- <div class="menu">
            <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>add</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
                 <button *ngIf="!isOnetoOne" mat-menu-item (click)="addNewParticipant(newParticipant)">
                    <mat-icon>group</mat-icon> Participants
                </button>
                <button mat-menu-item (click)="startNewGroup(newGroup)">
                    <mat-icon>group</mat-icon>
                    {{isOnetoOne?'New Group':'Add Participants'}}
                </button>
            </mat-menu>
        </div> -->
        <div class="call">
            <!-- <button mat-icon-button><mat-icon>stars</mat-icon></button> -->
            <button mat-icon-button color="primary" (click)="startNewGroup(newGroup)"><mat-icon>group_add</mat-icon></button>
        </div>
    </mat-card>
    <mat-card class="chatConatiner">
        <div class="" #scrollMe [scrollTop]="scrollMe.scrollHeight" style="overflow: auto;">
            <ng-container *ngFor="let msg of messageList">
                <div class="timeStamp">
                    <span>{{msg.dates| date:'EEE, MMM d, y'}}</span>
                    <!-- <span>wed, sep 25, 2019</span> -->
                </div>
                <ng-container *ngFor="let user of msg.values">
                    <div class="chatBlock" *ngIf="user.fromUser?.email != loggedinEmail">
                        <div class="userPic" *ngIf="user.fromUser?.profileImageUrl">
                            <img [src]="user.fromUser.profileImageUrl" alt="" />
                        </div>
                        <div class="userPic" *ngIf="!user.fromUser?.profileImageUrl">
                            <span>{{getShortName(user.fromUser?.userName)}}</span>
                        </div>
                        <div class="chatMessageWStamp">
                            <div class="nameDateIcons">
                                <!-- <span>{{user.createdOn | date:'MM/dd/yyyy h:mm a'}}</span> -->
                                {{user.fromUser?.userName}}, <span>{{user.createdOn | date:'h:mm a'}}</span>
                            </div>
                            <div class="chatMessage withFileMessage" *ngIf="user.filePath!=''">
                                <p (click)="openDocumentViewer(true,user,docViewer)">
                                    <mat-icon class="ftype"> description</mat-icon> {{user.fileName}}
                                </p>
                            </div>
                            <div class="chatMessage" *ngIf="user.message">
                                <p>{{user.message}}</p>
                                <!-- <div class="actionIcons">
                            <button mat-icon-button color=""> <mat-icon>thumb_up</mat-icon> </button>
                            <button mat-icon-button color=""> <mat-icon>bookmark_add</mat-icon> </button>
                        </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="chatBlock selfMessage" *ngIf="user.fromUser?.email == loggedinEmail">
                        <div class="userPic" *ngIf="user.fromUser?.profileImageUrl">
                            <img [src]="user.fromUser?.profileImageUrl" alt="" />
                        </div>
                        <div class="userPic" *ngIf="!user.fromUser?.profileImageUrl">
                            <span>{{getShortName(user?.fromUser.userName)}}</span>
                        </div>
                        <div class="chatMessageWStamp" *ngIf="user.fromUser?.email == loggedinEmail">
                            <div class="nameDateIcons">
                                <span>{{user.createdOn | date:'h:mm a'}}</span>
                            </div>
                            <div class="chatMessage withFileMessage" *ngIf="user.filePath!=''">
                                <p (click)="openDocumentViewer(true,user,docViewer)">
                                    <mat-icon class="ftype"> description</mat-icon> {{user.fileName}}
                                </p>
                            </div>
                            <div class="chatMessage" *ngIf="user.message">
                                <p>{{user.message}}</p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </mat-card>
    <mat-card class="postMessage">
        <div class="post">
            <div class="fileAttach" *ngIf="filepath!=''">
                <!-- File to send path: {{filepath}} -->
                <mat-icon class="ftype"> description</mat-icon> {{fileName}} <button mat-icon-button class="close"
                    color="basic" (click)="cancelUploadFile()">
                    <mat-icon>highlight_off</mat-icon>
                </button>
            </div>
            <textarea placeholder="Type your message" [(ngModel)]="message" (input)="onChange($event.target.value)"
                (keydown.enter)="onEnter($event)"></textarea>
        </div>
        <!-- <emoji-mart class="emoji-mart" set="{{set}}" *ngIf="showEmojiPicker" (emojiSelect)="addEmoji($event)" title="Pick your emoji…"></emoji-mart> -->
        <!-- <button mat-icon-button><mat-icon>insert_emoticon</mat-icon></button> -->
        <input #Input hidden="true" type="file" (change)="handleFileInput($event.target.files)">
        <button mat-icon-button (click)="Input.click()">
            <mat-icon>attach_file</mat-icon>
        </button>
        <button mat-icon-button color="primary" [disabled]="!sendButtonShow" (click)="send()">
            <mat-icon>send</mat-icon>
        </button>
    </mat-card>
</ng-container>

<ng-container *ngIf="groupname=='' || groupname==undefined">
    <div class="nouser">
        <mat-icon>chat</mat-icon>
        <p>Select user and start chat</p>
    </div>
</ng-container>

<ng-template #docViewer>
    <app-document-viewer (getCloseDocumentViewer)="getCloseDocumentViewer($event)" [ngClass]="{ open: documentViewer }">
    </app-document-viewer>
</ng-template>

<ng-template #newParticipant>
    <h2 mat-dialog-title>
        <span class="groupIcon">
            <mat-icon>chat_bubble_outline</mat-icon>
        </span>
        New Participant
        <button mat-icon-button (click)="clear()">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <mat-dialog-content class="mat-typography">
        
        <div class="searchUser">
            <mat-form-field appearance="fill">
                <mat-label>Search User</mat-label>
                <input matInput type="text" maxlength="20" (input)="SetSearchValue($event.target.value)">
            </mat-form-field>
            <button [disabled]="!isEnabled" mat-fab color="primary" (click)="SearchEmail()"><mat-icon>search</mat-icon> <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
            </mat-spinner></mat-icon></button>
            
        </div>

       
        <ul class="selectedlist">
            <li *ngFor="let user of peoples">
                <div class="userndetail" (click)='CreateNewParticipant()'>
                    <div class="pic" *ngIf="user.profileImagePath">
                        <img [src]="user.profileImagePath" alt="" />
                    </div>
                    <div class="pic" *ngIf="!user.profileImagePath">
                        <span>{{getShortNameEmail(user.email)}}</span>
                      </div>
                      <div class="detail">
                          <h4>{{user.email}}</h4>
                          <!-- <p>{{user.email}}</p> -->
                      </div>
                </div>
            </li>
        </ul>
    </mat-dialog-content>
</ng-template>

<ng-template #newGroup>
    <h2 mat-dialog-title>
        <span class="groupIcon">
            <mat-icon>chat_bubble_outline</mat-icon>
        </span>       
        Group Chat
        <button mat-icon-button (click)="clear()">
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <mat-dialog-content class="mat-typography">

        <mat-form-field appearance="outline">
            <mat-label>Group Name</mat-label>
            <input [disabled]="!isOnetoOne" matInput placeholder="Add Group Name" maxlength="50" [(ngModel)]="groupName"
                (input)="onChangegrp($event.target.value)" required>
        </mat-form-field>

        <ng-container *ngIf="selectedUser">
            <div class="selecList">
                <ng-container *ngFor="let use of selectedUser">
                    <div class="selec">
                        {{use.userName}} <span (click)='SelectUser(use)'>
                            <mat-icon>close</mat-icon>
                        </span>
                    </div>
                </ng-container>
            </div>
        </ng-container>

        <div class="searchUser">
            <mat-form-field appearance="fill">
                <mat-label>Search User</mat-label>
                <input matInput type="text" maxlength="20" (input)="SetSearchValue($event.target.value)">
            </mat-form-field>
            <button [disabled]="!isEnabled" mat-fab color="primary" (click)="SearchEmail()"><mat-icon>search</mat-icon><mat-icon *ngIf="spinner"><mat-spinner diameter="20">
            </mat-spinner></mat-icon></button> 
        </div> 

        <ul class="selectedlist">
            <li *ngFor="let user of peoples">
                <div class="userndetail" (click)='SelectUserFromCheckBox($event,user)'>
                    <div class="pic" *ngIf="user.profileImagePath">
                        <img [src]="user.profileImagePath" alt="" />
                    </div>
                    <div class="pic" *ngIf="!user.profileImagePath">
                        <span>{{getShortNameEmail(user.email)}}</span>
                      </div>
                      <div class="detail">
                          <h4>{{user.email}}</h4>
                          <!-- <p>{{user.email}}</p> -->
                      </div>
                </div>
                <div class="option">
                    <mat-checkbox color="primary" [ngModel]="user.isChecked"
                        (change)='SelectUserFromCheckBox($event,user)'></mat-checkbox>
                </div>
            </li>
        </ul>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button (click)="clear()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="!DoneButtonShow" (click)="CreateNewGroup()">Done</button>
    </mat-dialog-actions>
</ng-template>
